<template>
  <div>
    <v-row class="mt-0 mb-0">
      <v-col cols="12" md="4" class="pa--10 pt-16">
        <v-row class="ma-0" style="border: solid 1px; height: 850px; ">
          <v-col cols="12" class="pa-0">
            <v-data-table
              :custom-sort="$customSort"
              :headers="$getHeaderType2(headerTxt, claimDocHeadersEn, claimDocHeadersAr)"
              :items="claimDocList"
              hide-default-footer
              disable-pagination
              disable-sort
              :mobile-breakpoint="MobileBreakPoint"
              class="elevation-0 myapp_table_type2 type3"
            >
              <template v-slot:item="{ item }">
                <tr @click="fnViewPdf(item)">
                  <td class="text-left">{{ item.receipt_date }}</td>
                  <td class="text-center">{{ $vuetify.rtl ? item.lang_type_name_ar : item.lang_type_name_en }}</td>
                </tr>
              </template
            ></v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8" class="pa--10 pt-0">
        <div class="none__data__content" v-if="claimDocList.length === 0">
          <div class="thumb__bg"></div>
          <p>{{$t('common.message.no_document_list')}}</p>
        </div>
        <div class="none__data__content" v-if="claimDocList.length > 0 && !blnViewPdf">
          <div class="thumb__bg"></div>
          <p>{{$t('common.message.click_file_name')}}</p>
        </div>
        <pdf-viewer height="850px" :url="pdfUrl" v-if="claimDocList.length > 0 && blnViewPdf"></pdf-viewer>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import PdfViewer from '@/components/layout/PdfViewer.vue'

export default {
  props: {
    seq:  String
  },
  components:{
    PdfViewer
  },
  data () {
		return {
      MobileBreakPoint:0,
      blnViewPdf: false,
      headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ 'date', 'type' ]
      },
      claimDocHeadersAr : [
        { text: this.$t('myapplication.myapplication_details.fields.date'), align: 'left', value: 'receipt_date', },
        { text: this.$t('myapplication.myapplication_details.fields.type'), align: 'center', value: 'lang_type_name_ar'  }
      ],
      claimDocHeadersEn : [
        { text: this.$t('myapplication.myapplication_details.fields.date'), align: 'left', value: 'receipt_date', },
        { text: this.$t('myapplication.myapplication_details.fields.type'), align: 'center', value: 'lang_type_name_en'  }
      ],
      claimDocList : [],

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      pdfUrl: ''
    }
  },
  mounted(){
    this.fnGetClaimDocs()

  },
  methods : {
    fnGetClaimDocs(){
      requestApi({
        url: '/applications/' + this.seq + '/claims/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.claimDocList = res.data.list
         } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetClaimDocs()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnViewPdf(item) {
      let file_key = item.file_key
      if (item.pdf_file_name !== '') {
        this.pdfUrl = this.downLoadUrl + file_key +'/pdf/'+ item.pdf_file_name
      } else {
        this.pdfUrl = ''
      }
      this.blnViewPdf = true
    },
    fnIsNotNull(fileKey){
      return !utils.isNull(fileKey)
    }
  }
}
</script>